import { render } from "./index-4.vue?vue&type=template&id=5c39f44b"
import script from "./index-4.vue?vue&type=script&lang=js"
export * from "./index-4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__